export const dir = {
  agencyCode: '313',
  name: 'Texas Department of Information Resources',
  shortName: 'DIR',
  slug: 'dir',
};
